import Filter from './filter'
import connect from './connect'

export default connect(Filter)
